import styled from "styled-components";


export const Container = styled.main`
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    background-image: linear-gradient(var(--secondaryColor), var(--mainColor));
`;